const hashSet: {
  name: string;
  hideScroll: boolean;
}[] = [];

const ScrollBarService = {
  getScrollBarWidth() {
    const scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  },
  applyModalOpen(value: boolean, name: string, hideScroll = false) {
    const inHashSet = hashSet.filter((s) => s.name === name).length !== 0;
    if (inHashSet && value === false) {
      const index = hashSet.findIndex((hs) => hs.name === name);
      hashSet.splice(index, 1);
    } else if (!inHashSet && value === true) {
      hashSet.push({ name, hideScroll });
    }

    let hasScroll: boolean;
    if (
      (document.body.parentElement as HTMLElement).scrollHeight >
      (document.body.parentElement as HTMLElement).clientHeight
    ) {
      hasScroll = true;
    } else {
      hasScroll = false;
    }

    const modalOpenClass = "modal-open";
    const header = document.getElementById(
      "main-header-container-id"
    ) as HTMLElement;

    hideScroll = hashSet.filter((hs) => hs.hideScroll).length !== 0;

    if (hashSet.length > 0) {
      document.body.classList.add(modalOpenClass);
      const scrollBarWidth = ScrollBarService.getScrollBarWidth();

      if (scrollBarWidth > 0 && hasScroll) {
        header.style.width = "calc(100% - " + scrollBarWidth + "px)";
      }

      if (scrollBarWidth > 0 && hasScroll && hideScroll) {
        (document.body.parentElement as HTMLElement).style.paddingRight =
          scrollBarWidth + "px";
      } else {
        if (scrollBarWidth > 0 && !hasScroll && hideScroll) {
          (document.body.parentElement as HTMLElement).style.paddingRight =
            scrollBarWidth + "px";
          document.body.classList.remove("disable-scroll");
        } else {
          document.body.classList.add("disable-scroll");
        }
      }
    } else {
      document.body.classList.remove(modalOpenClass);
      document.body.classList.remove("disable-scroll");
      (document.body.parentElement as HTMLElement).style.paddingRight = "0px";
      header.style.width = "100%";
    }
  },
};

export default ScrollBarService;
